export const getEndOfYear = (): Date => {
  const endOfYear = new Date()
  endOfYear.setMonth(11, 31)
  return endOfYear
}

export const tolLocalDateFormat = (date: Date): string => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()

  return `${year}-${month > 9 ? month : `0${month}`}-${day > 9 ? day : `0${day}`}`
}

export const getDateFromLocalDateString = (dateString: string) => {
  const data = dateString.split('-').map((it) => parseInt(it, 10))
  return new Date(data[0], data[1] - 1, data[2])
}

export const toPrintFormat = (date: string | Date): string => {
  // TODO: Change locale back to nb-NO when Chrome bug is fixed, see ETU-18289.
  return new Date(date).toLocaleString('da-DK', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
}

export const toSsnFormat = (date: string | Date): string => {
  // TODO: Change locale back to nb-NO when Chrome bug is fixed, see ETU-18289.
  return new Date(date)
    .toLocaleString('da-DK', {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
    })
    .replace(/\./g, '')
}

export const calculateAge = (birthday: Date) => {
  const ageDifMs = Date.now() - birthday.getTime()
  const ageDate = new Date(ageDifMs)
  return Math.abs(ageDate.getUTCFullYear() - 1970)
}

export const isSeniorCitizenByAge = (birthday: Date | string): boolean => {
  return calculateAge(new Date(birthday)) >= 67
}

const reISO = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/

export const dateParser = (key: string, value: string) => {
  if (typeof value === 'string') {
    const a = reISO.exec(value)
    if (a) return new Date(value)
  }
  return value
}
